export default __webpack_public_path__ + "static/media/setion06_bg.82adff93.jpg";